import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, of, Subscription } from 'rxjs';
import { catchError, startWith, switchMap, timeout } from 'rxjs/operators';
import { RecipientRepositoryService, RecipientStory, RecipientNews } from '../services/recipient-repository.service';

@Component({ selector: 'app-recipient-detail', templateUrl: './recipient-detail.component.html', styleUrls: ['./recipients.scss'] })
export class RecipientDetailComponent implements OnInit, OnDestroy {
  readonly preview = false;
  readonly previewStatus = '';
  story: RecipientStory; updates: RecipientNews[] = [];
  loading = true; error = ''; updatesError = ''; updatesLoading = false;
  private subscription = new Subscription();
  constructor(private repository: RecipientRepositoryService, private route: ActivatedRoute) {}
  get returnPath(): string {
    return '/' + this.route.parent.snapshot.pathFromRoot.map(part => part.url.map(segment => segment.path).join('/')).filter(Boolean).join('/');
  }
  ngOnInit(): void {
    this.subscription = combineLatest([this.route.paramMap, this.repository.changes.pipe(startWith(null))]).pipe(switchMap(([params]) => {
      this.story = null; this.updates = []; this.error = ''; this.updatesError = ''; this.loading = true; this.updatesLoading = false;
      const slug = params.get('slug') || '';
      const read = params.has('challengeId') ? this.repository.loadLegacyStory(Number(params.get('challengeId')), slug) : this.repository.loadStory(slug);
      return read.pipe(timeout(20000),
        switchMap(story => {
          this.story = story; this.loading = false;
          if (!story) { return of([]); }
          this.updatesLoading = true;
          return this.repository.loadUpdates(story).pipe(timeout(20000), catchError(() => {
            this.updatesError = 'Unable to load updates. Please try again.'; return of([]);
          }));
        }), catchError(() => { this.error = 'Unable to load this story. Please try again.'; return of([]); }));
    })).subscribe(updates => { this.updates = updates; this.loading = false; this.updatesLoading = false; });
  }
  reload(): void { this.repository.refresh(); }
  updateStatus(update: RecipientNews): string { return ''; }
  ngOnDestroy(): void { this.subscription.unsubscribe(); }
}
